import { QueryClient, useQuery } from "@tanstack/react-query";

export const QUERY_KEY_FETCH_IMG_OBJ_URL = "QUERY_KEY_FETCH_IMG_OBJ_URL";

interface Props {
  img_id: string;
  image_url: string;
}

export const fetchImgObjUrl = async (props: Props): Promise<string> => {
  const blob = await fetch(props.image_url).then((r) => r.blob());
  return URL.createObjectURL(blob);
};

export const fetchImgObjUrlOptions = (props: Props) => {
  return {
    queryKey: [QUERY_KEY_FETCH_IMG_OBJ_URL, props.img_id],
    queryFn: () => fetchImgObjUrl(props),
    staleTime: Infinity,
    gcTime: 5 * 60 * 1000,
  };
};

export const useFetchImgObjUrl = (props: Props) => {
  return useQuery({
    ...fetchImgObjUrlOptions(props),
    enabled: !!props.img_id && !!props.image_url,
  });
};

// Call ONCE, right after you create your QueryClient. Returns an unsubscribe fn.
export const setupImgObjUrlRevocation = (queryClient: QueryClient) =>
  queryClient.getQueryCache().subscribe((event) => {
    if (event.type !== "removed") return;
    if (event.query.queryKey[0] !== QUERY_KEY_FETCH_IMG_OBJ_URL) return;
    const objUrl = event.query.state.data as string | undefined;
    if (objUrl) URL.revokeObjectURL(objUrl);
  });
